import { render, staticRenderFns } from "./ModalCreatePolygonFromCoordinates.vue?vue&type=template&id=1a0f3db5"
import script from "./ModalCreatePolygonFromCoordinates.vue?vue&type=script&lang=ts"
export * from "./ModalCreatePolygonFromCoordinates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports